import React from "react";
import isEmpty from "lodash/isEmpty";
import styled from "styled-components";
import { Trans, useTranslation } from "react-i18next";
import { Timestamp } from "components/common";
import { formatNumber } from "util/NumberFormatting";
import useGlobalOverride from "views/hooks/useGlobalOverride";
import useViewType from "views/hooks/useViewType";
import View from "views/logic/views/View";
const EffectiveTimeRange = styled.div`
  margin-bottom: 10px;
`;
const EffectiveTimeRangeTable = styled.table`
  margin-bottom: 5px;

  td:first-child {
    padding-right: 10px;
  }
`;
const SearchResultOverview = ({ results }) => {
  var _a, _b, _c;
  const { t } = useTranslation("search");
  const { timerange: globalOverrideTimeRange } = (_a = useGlobalOverride()) != null ? _a : {};
  const viewType = useViewType();
  if (isEmpty(results)) {
    return /* @__PURE__ */ React.createElement("i", null, t("sidebar_description.no_query"));
  }
  const { timestamp, duration, effectiveTimerange, searchTypes } = results;
  const total = searchTypes && ((_c = (_b = Object.values(searchTypes)) == null ? void 0 : _b[0]) == null ? void 0 : _c.total);
  const isVariesPerWidget = viewType === View.Type.Dashboard && !globalOverrideTimeRange;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, t("sidebar_description.query_executed_in"), " ", /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "search_result_overview.duration_at",
      values: { duration: formatNumber(duration, { digits: 0 }) },
      components: { timestamp: /* @__PURE__ */ React.createElement(Timestamp, { dateTime: timestamp }) }
    }
  )), /* @__PURE__ */ React.createElement(EffectiveTimeRange, null, t("sidebar_description.effective_time_range"), /* @__PURE__ */ React.createElement("br", null), isVariesPerWidget ? /* @__PURE__ */ React.createElement("i", null, t("sidebar_description.varies_per_widget")) : /* @__PURE__ */ React.createElement(EffectiveTimeRangeTable, null, /* @__PURE__ */ React.createElement("tbody", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", null, t("sidebar_description.time_from")), /* @__PURE__ */ React.createElement("td", { "aria-label": t("search_result_overview.effective_from") }, /* @__PURE__ */ React.createElement(Timestamp, { dateTime: effectiveTimerange.from, format: "complete" }))), /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", null, t("sidebar_description.time_to")), /* @__PURE__ */ React.createElement("td", { "aria-label": t("search_result_overview.effective_to") }, /* @__PURE__ */ React.createElement(Timestamp, { dateTime: effectiveTimerange.to, format: "complete" })))))), /* @__PURE__ */ React.createElement("p", null, t("sidebar_description.total_results"), /* @__PURE__ */ React.createElement("br", null), isVariesPerWidget ? /* @__PURE__ */ React.createElement("i", null, t("sidebar_description.varies_per_widget")) : formatNumber(total, { digits: 0 })));
};
export default SearchResultOverview;
